export default __webpack_public_path__ + "media/zurb/img/services/tools/foundation-screenshot2-31398617967e08d3ce97905a7d820f75.png";